export default __webpack_public_path__ + "static/media/Declaration of Independence_06.97e212e2.jpg";